/**
 * 国际化配置
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入语言包
import zhCN from './zh-CN';
import enUS from './en-US';
import zhTW from './zh-TW';

// 语言资源
const resources = {
  'zh-CN': {
    translation: zhCN,
  },
  'en-US': {
    translation: enUS,
  },
  'zh-TW': {
    translation: zhTW,
  },
};

// 支持的语言列表
export const supportedLanguages = [
  {
    key: 'zh-CN',
    label: '简体中文',
    flag: '🇨🇳',
  },
  {
    key: 'en-US',
    label: 'English',
    flag: '🇺🇸',
  },
  {
    key: 'zh-TW',
    label: '繁體中文',
    flag: '🇹🇼',
  },
];

// 获取默认语言
export const getDefaultLanguage = (): string => {
  // 从localStorage获取
  const stored = localStorage.getItem('tenant-language');
  if (stored && supportedLanguages.some(lang => lang.key === stored)) {
    return stored;
  }

  // 从浏览器语言检测
  const browserLang = navigator.language || navigator.languages?.[0];
  if (browserLang) {
    // 繁体中文检测
    if (browserLang === 'zh-TW' || browserLang === 'zh-HK' || browserLang === 'zh-Hant') {
      return 'zh-TW';
    }
    // 简体中文
    if (browserLang.startsWith('zh')) {
      return 'zh-CN';
    }
    // 英文
    if (browserLang.startsWith('en')) {
      return 'en-US';
    }
  }

  // 默认中文
  return 'zh-CN';
};

// 切换语言
export const changeLanguage = (lang: string): void => {
  if (supportedLanguages.some(l => l.key === lang)) {
    localStorage.setItem('tenant-language', lang);
    i18n.changeLanguage(lang);
    // 更新 HTML lang 属性
    document.documentElement.lang = lang;
  }
};

// 初始化i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getDefaultLanguage(),
    fallbackLng: 'zh-CN',

    // 插值配置
    interpolation: {
      escapeValue: false,
    },

    // 检测器配置
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'tenant-language',
    },

    // 开发模式配置
    debug: import.meta.env.DEV,

    // 命名空间
    defaultNS: 'translation',
  });

export default i18n;